import { sha256 } from "js-sha256";

export const Password = (id, pw) => {
  return sha256(id.trim() + "eocs" + pw);
};
